<svg  [attr.width]="width" [attr.height]="height">
  <polygon [attr.points]="swatchPolyPoints" [attr.fill]="fillColor"/>
  <line x1="0" [attr.y1]="lineY" [attr.x2]="width" [attr.y2]="lineY" [attr.stroke]="color" [attr.stroke-width]="thickness"
    [attr.stroke-dasharray]="swatchDashArray" [attr.stroke-dashoffset]="swatchDashOffset"
  ></line>
</svg>
